<div class="alert alert-inverse align-middle" *ngFor="let message of text">
  <p class="m-0">
    <em class="fa-lg icon-info mr-2 text-warning align-text-bottom"></em>
    {{ message.message | translate }}
    <a *ngIf="message.link" routerLink="{{ message.url }}">
      <span class="text-warning">{{ message.link_text | translate }}</span>
    </a>
  </p>
</div>
